// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"421083cb","453":"fd895717","506":"dd7177bd","527":"e8c4f3e3","625":"4c4a44c6","643":"91f4dbcd","647":"a150e90d","671":"6a1fe459","940":"2222ea78"}[chunkId] + ".chunk.js";
};